import { max } from 'date-fns-jalali';
import { 
    ADD_LOG_MESSAGE,
    CLEAR_LOG_MESSAGES
} from '../actions/log-actions';

const initialState = {
    messages: [],
    max: 200,
};

const logReducer = (state = initialState, action) => {
    switch(action.type) {
        case ADD_LOG_MESSAGE:
            // Avoid state mutation - create new array properly
            const newMessages = state.messages.length >= state.max 
                ? [...state.messages.slice(1), action.message] // Remove first, add new
                : [...state.messages, action.message]; // Just add new
            
            return {
                ...state,
                messages: newMessages
            };
        case CLEAR_LOG_MESSAGES:
            return {
                ...state,
                messages: []
            };
        default:
            return state;
    }
}

export default logReducer;